export enum LegContextMenuActions {
    UNDO_ACTION = "UNDO_ACTION",
    SET_AS_DISPATCHABLE = "SET_AS_DISPATCHABLE",
    REPLAN = "REPLAN",
};